import axios from 'axios'

function getCurrentPrice(fields) {
  return Object.keys(fields).reduce((sum, fieldId) => {
    const field = fields[fieldId].value
    if (Array.isArray(field)) {
      sum += field.reduce((s, v) => {
        if (v.price) {
          if (v.count) s += parseFloat(v.price) * parseFloat(v.count)
          else s += parseFloat(v.price)
        }
        return s
      }, 0)
    } else {
      if (field && field.price) {
        if (field.count) sum += parseFloat(field.price) * parseFloat(field.count)
        else sum += parseFloat(field.price)
      }
    }
    return sum
  }, 0)
}

export default {
  namespaced: true,
  state: {
    order: {
      fieldsValues: [],
      currentPrice: 0
    },
    valid: false,
    error: null,
    loading: false
  },
  mutations: {
    setFieldValue(state, field) {
      state.order = {
        fieldsValues: {
          ...state.order.fieldsValues,
          [field.id]: { value: field.value, valid: field.valid }
        }
      }

      state.order.currentPrice = getCurrentPrice(state.order.fieldsValues)
    },
    setInitialFieldsValue(state, initialOrderFieldsValues) {
      state.order = {
        fieldsValues: { ...initialOrderFieldsValues },
        currentPrice: getCurrentPrice(state.order.fieldsValues)
      }
    },
    setOrder(state, order) {
      state.order = {
        ...order
      }
    },
    setLoading(state, isLoading) {
      state.loading = isLoading
    },
    setError(state, error) {
      state.error = error
    }
  },
  actions: {
    setFieldValue({ commit }, field) {
      commit('setFieldValue', field)
    },
    setInitialFieldsValue({ commit }, initialOrderFieldsValues) {
      commit('setInitialFieldsValue', initialOrderFieldsValues)
    },
    loadOrderById({ commit }, orderId) {
      commit('setLoading', true)
      commit('setError', null)
      axios
        .get(`${process.env.VUE_APP_API_URL}/orders/${orderId}`)
        .then(res => res.data.order)
        .then(order => {
          commit('setOrder', order)
        })
        .catch(err => {
          commit('setError', err)
        })
        .finally(() => commit('setLoading', false))
    }
  },
  getters: {
    getEditedOrder: state => {
      return state.order
    },
    isLoading: state => {
      return state.loading
    },
    isError: state => {
      return state.error
    }
  }
}
